import React from "react";
import Icon from "../icon/Icon";
import { useNavigate } from "../../helpers/navigationHelpers";

interface Props {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
}

const BackButton: React.FC<Props> = (props): React.ReactElement => {
  const { goBack } = useNavigate();

  return (
    <Icon
      onClick={(e) => props.onClick?.(e) ?? goBack()}
      name="chevron-left"
      className={`cursor-pointer ${props.className}`}
    />
  );
};

export default BackButton;
